import React, { useEffect } from 'react';
import { Container, Grid, Paper, Typography, Button } from '@mui/material';
import Navigation from '../components/Navbar';
import Footer from '../components/Footer';
import './Pricing.css';
import heroImage from '../assets/images/Logo.png';

const plans = [
    {
        sectionTitle: "Premium Social Media Packages",
        sectionDescription: "Boost your brand's online presence with our top-tier social media marketing plans.",
        plans: [
            {
                title: "POWER STAR",
                price: "₹24,999 per month",
                features: [
                    "1 Daily Posting (30 Creatives Incl. Festival Post)",
                    "1 Photoshoot",
                    "6-8 Reels (Incl Voiceover Reels)",
                    "We Handle FB & Instagram",
                    "Meta Campaign (Based on your Budget)"
                ]
            },
            {
                title: "MEGA STAR",
                price: "₹29,999 per month",
                features: [
                    "1 Daily Posting (30 Creatives Incl. Festival Post)",
                    "2 Photoshoots",
                    "8-10 Reels (Incl Voiceover Reels)",
                    "Basic SEO",
                    "We Handle FB & Instagram",
                    "Meta, Google Ad Campaign (Based on your Budget)"
                ]
            }
        ]
    },
    {
        sectionTitle: "Special Packages for Businesses",
        sectionDescription: "Advanced social media and SEO plans tailored for your business growth.",
        plans: [
            {
                title: "MODERN MAHALAXMI",
                price: "₹24,999 per month",
                features: [
                    "FB, Instagram & Google Management",
                    "Basic SEO (3-5 Keywords, Weekly Updates, Reviews)",
                    "1 Daily Posting",
                    "6-8 Reels",
                    "1 Photoshoot",
                    "Meta Campaign (Based on your Budget)"
                ]
            },
            {
                title: "DIGITAL MAHALAXMI",
                price: "₹34,999 per month",
                features: [
                    "FB, Instagram & Google Management",
                    "Basic SEO (5-7 Keywords, Weekly Updates, Reviews)",
                    "1 Daily Posting",
                    "6-8 Reels",
                    "2 Photoshoots",
                    "Meta Campaign (Based on your Budget)"
                ]
            },
            {
                title: "VAYARI BHAMALLU",
                price: "₹34,999 per month",
                features: [
                    "FB, Instagram & Google Management",
                    "1 Daily Posting (30 Creatives Incl. Festival Post)",
                    "6-8 Reels (Incl Voiceover Reels)",
                    "2 Photoshoots",
                    "Meta Campaign (Based on your Budget)"
                ]
            }
        ]
    },
    {
        sectionTitle: "Fly Higher with Our Elite Package",
        sectionDescription: "A premium package with drone shoots and advanced campaign management.",
        plans: [
            {
                title: "FLY-HIGH",
                price: "₹39,999 per month",
                features: [
                    "FB, Instagram & Google Management",
                    "1 Daily Posting (30 Creatives Incl. Festival Post)",
                    "6-8 Reels (Incl Voiceover Reels)",
                    "2 Photoshoots",
                    "2 Drone Photoshoots",
                    "Meta Campaign (Based on your Budget)"
                ]
            }
        ]
    },
    {
        sectionTitle: "Affordable Packages for Non-Locals",
        sectionDescription: "Exclusive digital marketing solutions tailored for remote businesses.",
        plans: [
            {
                title: "STANDARD",
                price: "₹24,999 per month",
                features: [
                    "1 Photoshoot",
                    "Creatives (30 days)",
                    "4-6 Reels",
                    "Basic SEO",
                    "Campaign Services (Based on your Budget)"
                ]
            },
            {
                title: "PREMIUM",
                price: "$499 per month",
                features: [
                    "2 Photoshoots",
                    "Creatives (30 days)",
                    "4-6 Reels",
                    "Basic SEO",
                    "Campaign Services (Based on your Budget)",
                    "Google Business Listing (If Required)",
                    "LED Screen Advertising"
                ]
            }
        ]
    }
];

const Pricing = () => {
    return (
        <>
            <Navigation />
            <Container className="pricing-container">
                {/* Page Header */}
                <Typography variant="h3" className="page-header">
                    Your Path to Promotional Success
                </Typography>
                <Typography variant="body1" className="page-description">
                    Brand Promoter in Hyderabad - Hashkaro Digitals offers tailored promotion packages to boost your 
                    online presence and drive growth. Explore our flexible pricing options to find the perfect fit 
                    for your business needs.
                </Typography>

                {/* Sections */}
                {plans.map((section, index) => (
                    <div key={index} className="pricing-section">
                        <Typography variant="h4" className="section-heading">
                            {section.sectionTitle}
                        </Typography>
                        <Typography variant="body1" className="section-description">
                            {section.sectionDescription}
                        </Typography>
                        
                        <Grid container spacing={4} alignItems="center">
                            {/* Image */}
                            <Grid item xs={12} md={4}>
                                <img src={heroImage} alt={section.sectionTitle} className="section-image" />
                            </Grid>

                            {/* Plans */}
                            <Grid item xs={12} md={8}>
                                <Grid container spacing={4}>
                                    {section.plans.map((plan, idx) => (
                                        <Grid item xs={12} md={6} key={idx}>
                                            <Paper className="plan-card">
                                                <Typography variant="h5" className="plan-title">{plan.title}</Typography>
                                                <Typography className="plan-price">{plan.price}</Typography>
                                                <ul className="plan-features">
                                                    {plan.features.map((feature, fIdx) => (
                                                        <li key={fIdx}>{feature}</li>
                                                    ))}
                                                </ul>
                                                <Button variant="contained" className="plan-button">
                                                    Get it NOW
                                                </Button>
                                            </Paper>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                ))}
            </Container>
            <Footer />
        </>
    );
};

export default Pricing;